import React from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { useThemeClasses } from '../../../hooks/useThemeClasses';

/**
 * B-06 — Body parts: Check Availability + Add to Cart. No Express Buy — ever.
 */
export default function BodyCtaSection({
  listing,
  onCheckAvailability,
  onAddToCart,
  checking,
  addingToCart,
  requestSent,
  compact = false,
}) {
  const { isDark } = useThemeClasses();
  const photosOk = listing?.photoVerified !== false;
  const btnPy = compact ? 'py-3.5' : 'py-4';

  const addToCartBtn = (
    <button
      type="button"
      onClick={onAddToCart}
      disabled={!photosOk || addingToCart}
      className={`flex w-full items-center justify-center gap-2 rounded-xl border-2 px-5 ${btnPy} text-base font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
        isDark
          ? 'border-amber-500 text-amber-400 hover:bg-amber-500/10'
          : 'border-slate-800 bg-white text-slate-900 hover:bg-slate-50'
      }`}
    >
      <FaShoppingCart className="text-sm" />
      {addingToCart ? 'Adding…' : 'Add to Cart'}
    </button>
  );

  if (requestSent) {
    return (
      <div className="w-full space-y-3">
        <div
          className={`rounded-2xl border p-5 text-center sm:p-6 ${
            isDark
              ? 'border-emerald-700/50 bg-emerald-950/30'
              : 'border-emerald-200 bg-emerald-50'
          }`}
        >
          <p className={`font-semibold ${isDark ? 'text-emerald-200' : 'text-emerald-800'}`}>
            Request sent — awaiting seller response.
          </p>
          <p className={`mt-2 text-sm ${isDark ? 'text-emerald-300/80' : 'text-emerald-700'}`}>
            The seller will check this panel and send a pre-dispatch photo for your approval.
            You can add this part to your cart while you wait.
          </p>
        </div>
        {addToCartBtn}
      </div>
    );
  }

  return (
    <div className="w-full space-y-3">
      <div
        className={`rounded-xl border px-4 py-3 text-sm ${
          isDark
            ? 'border-blue-700/40 bg-blue-950/25 text-blue-200'
            : 'border-blue-200 bg-blue-50 text-blue-800'
        }`}
      >
        {listing?.preDispatchNotice ||
          'Seller will send a photo of this specific panel before it ships. You approve before shipment.'}
      </div>

      {!photosOk && (
        <div
          className={`rounded-xl border px-4 py-3 text-sm ${
            isDark
              ? 'border-amber-700/50 bg-amber-950/30 text-amber-200'
              : 'border-amber-200 bg-amber-50 text-amber-800'
          }`}
        >
          Seller is completing photo verification.
        </div>
      )}

      <div className={`grid w-full grid-cols-1 gap-3 ${compact ? '' : 'sm:grid-cols-2'}`}>
        <button
          type="button"
          onClick={onCheckAvailability}
          disabled={!photosOk || checking}
          className={`flex w-full items-center justify-center rounded-xl bg-amber-500 px-5 ${btnPy} text-base font-bold text-slate-900 transition-colors hover:bg-amber-400 disabled:cursor-not-allowed disabled:opacity-50`}
        >
          {checking ? 'Sending…' : 'Check Availability'}
        </button>
        {addToCartBtn}
      </div>
    </div>
  );
}
